/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow strict-local
 */

export default function createCSSStyleSheet(
  id: string,
): CSSStyleSheet | null | undefined {
  // using `typeof window !== 'undefined'` instead of `canUseDom`,
  // so it can be injected by jsdom
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    let element = document.getElementById(id) as HTMLStyleElement
    if (element != null) {
      return element.sheet
    }
    element = document.createElement("style")
    element.setAttribute("id", id)
    const head = document.head
    if (head) {
      head.insertBefore(element, head.firstChild)
    }
    return element.sheet
  }
  return null
}
